// Import services
import services from 'services/services';

// Import types
import { SubscriberApi } from 'helpers/api/subscriber_api';

type Response = {
	message: boolean;
};

export const fetchIsPurchaseAvailable = () =>
	services.get<Response>('/payments/country/isPurchaseAvailable').then((response) => {
		if (response.data.message) {
			return true;
		} else {
			throw Error;
		}
	});

export const fetchInEog = () =>
	services.get<Response>(SubscriberApi.InPoland).then((response) => {
		if (response.data.message) {
			return true;
		} else {
			throw Error;
		}
	});
